




import React from 'react';
import { Box, Typography } from '@mui/material';

const CustomEmailInput = ({
  placeholder,
  value,
  onChange,
  onBlur,
  name = 'email',
  width,
  height = '42px',
  fontSize = '14px',
  borderColor = '#091E4224',
  focusBorderColor = '#006EC2',
  placeholderColor = '#A0A0A0',
  borderRadius = '6px',
  error = false,
  helperText = "",
  ...rest
}) => {
  return (
    <Box sx={{ width: width || '100%' }}>
      <Box
        sx={{
          height,
          display: 'flex',
          alignItems: 'center',
          // border: `2px solid ${error ? '#d32f2f' : borderColor}`,
            border:error
      ? "1px solid red"
      :"2px solid  #091E4224",
          borderRadius,
          px: 1.5,
          '&:focus-within': {
            // border: `2px solid ${error ? '#d32f2f' : focusBorderColor}`,
              border:error
      ? "1px solid red"
      :"2px solid  #006EC2",
          },
        }}
      >
        <Box
          component="input"
          type="email"
          name={name}
          value={value}
          onChange={onChange}
          onBlur={onBlur}
        placeholder={placeholder || 'john@gmail.com'}
          sx={{
            border: 'none',
            outline: 'none',
            fontSize,
            width: '100%',
            height: '100%',
            fontFamily: 'Poppins, sans-serif',
            color: '#333',
            '::placeholder': { color: placeholderColor },
          }}
          {...rest}
        />
      </Box>
      {error && (
        <Typography sx={{ fontSize: 12, color: '#d32f2f', mt: 0.5 }}>
          {helperText}
        </Typography>
      )}
    </Box>
  );
};

export default CustomEmailInput;
